export default __webpack_public_path__ + "assets/images/b98dc955d66e2fab1ce102ecd1374004.png";